<canvas #canvas></canvas>
<ng-container #template></ng-container>
<div class="text" #text>
  <span [class.percent]="type === ECirclePercentType.PERCENT">{{ (type === ECirclePercentType.TIME) ? (value | numbertotime) : (value === undefined ? '--' : value) }}</span>
</div>
